import { useContext } from 'react';

import { AntModalContext } from '../contexts/ant-modal-context';

export function useAntModal() {
    return useContext(AntModalContext);
}
